import axiosInstance from "./axiosInstance";

const API_URL =
  process.env.REACT_APP_NAS_API_URL || "https://new.aquastrong-select.ru";

export const fetchCategories = () =>
  axiosInstance.get(`${API_URL}/api/v1/products/categories`);

export const fetchCategorySeries = (categoryId) =>
  axiosInstance.get(
    `${API_URL}/api/v1/products/categories/${categoryId}/series`
  );

export const fetchSeriesDetails = (seriesId) =>
  axiosInstance.get(`${API_URL}/api/v1/products/series/${seriesId}`);
